<template>
  <div>
    <div class="fixed inset-0" @click.stop="emitClose"></div>
    <div class="absolute self-end bg-white mt-2 p-4 right-0 z-50 text-black shadow-md min-w-xs">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "DropDown",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    emitClose() {
      this.$emit("close");
    }
  },
  computed: {},
  created() {}
};
</script>